module.exports = __webpack_public_path__ + "img/game.51cf05e4.svg";